import { Overline } from "../ui-regera/Section";

/* One meaningful section of a page. On large screens it is presented as a frame;
   on phones it is an ordinary section that scrolls naturally. */
export const Frame = ({ id, anchor, testId, className = "", first = false, children }) => (
  <section
    id={anchor}
    data-frame={id}
    data-testid={testId}
    className={`rg-sframe ${first ? "rg-sframe-first" : "border-t border-white/10"} ${className}`}
  >
    <div className="mx-auto max-w-[1600px] w-full px-5 sm:px-8 lg:px-12">{children}</div>
  </section>
);

// `fit`: in desktop frames, heading and intro text scale with the screen height (see .rg-fs-* in index.css).
export const Head = ({ overline, title, body, as = "h2", className = "", size = "md", fit = false }) => {
  const H = as;
  const sz =
    size === "lg"
      ? "text-4xl sm:text-5xl xl:text-6xl"
      : "text-3xl sm:text-4xl xl:text-5xl";
  return (
    <div className={className}>
      {overline && <Overline>{overline}</Overline>}
      <H data-pg-label className={`mt-5 font-display font-black text-white tracking-tight leading-[1.04] ${sz} max-w-4xl ${fit ? (size === "lg" ? "rg-fs-display" : "rg-fs-title") : ""}`}>
        {title}
      </H>
      {body && <p className={`mt-5 text-white/75 text-base lg:text-lg leading-relaxed max-w-3xl ${fit ? "rg-fs-lead" : ""}`}>{body}</p>}
    </div>
  );
};
